// FlagButton.js
import React from 'react'
import { RoundShadowButton } from 'components'
import { flagLogo, unFlagLogo } from 'images'

const FlagButton = ({ hovered, flagged, onClick }) => {
  return (
    <div className="w-6 mr-6">
      {hovered && (
        <RoundShadowButton
          removeTextComponent
          icon={!flagged ? flagLogo : unFlagLogo}
          cicleWidthClass="w-6"
          imageWidthClass="w-2"
          onClick={onClick}
        />
      )}
    </div>
  )
}

export default FlagButton
